import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HashRouter } from "react-router-dom";
import { ConfigProvider ,Spin} from 'antd';
import {
  RecoilRoot,
} from 'recoil';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import enUS from "antd/lib/locale-provider/en_US";
import koKR from "antd/lib/locale-provider/ko_KR";
import { initI18n, getLocale } from './i18n';


function getLocalLanguage(localLang: string) {
  switch (localLang) {
    default:
      return zhCN;
    case "zh-CN":
      return zhCN;
    case "en-US":
      return enUS;
    case "ko-KR":
      return koKR;
  }
}

initI18n()

// 修改主渲染逻辑
ReactDOM.render(
  <RecoilRoot>
    <ConfigProvider locale={getLocalLanguage(getLocale())}>
      <HashRouter>
        <Suspense fallback={<div style={{width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}><Spin /></div>}>
          <App />
        </Suspense>
      </HashRouter>
    </ConfigProvider>
  </RecoilRoot>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

